import React from "react";

export const Image = ({
  webpSrc,
  pngSrc,
  alt,
  modeWebp = true,
  classNameContent = "",
  ...props
}) => {
  let _webpSrc =
    webpSrc || String(pngSrc).replace(/(.png|.jpg|.gif)$/gi, ".webp");
  _webpSrc = String(_webpSrc).includes(".webp") ? _webpSrc : undefined;

  return (
    <picture className={classNameContent}>
      <source srcSet={_webpSrc} type="image/webp" />
      <source srcSet={pngSrc} type="image/png" />
      <img src={pngSrc} alt={alt} {...props} />
    </picture>
  );
};
